<script>
import ListBase from '@/components/ListBase';
import { mapState } from 'vuex';

export const DESCARGAR_ACTION = 'Descargar';
export const formulariosHeader = [
  { text: 'Id', value: 'id', customSortField: 'idFormulario' },
  { text: 'Nro. de Guía', value: 'nroGuia' },
  { text: 'Código TEES', value: 'codigoTees' },
  { text: 'Código Despacho', value: 'codigoDespacho' },
  { text: 'Exportador', value: 'razonSocialExportador', },
  { text: 'RUC Exportador', value: 'rucExportador', customSortField: 'exportador.ruc'  },
  { text: 'Importador', value: 'nombreImportador', customSortField: 'importador.nombre' },
  { text: 'Pais Destino', value: 'paisImportador', customSortField: 'importador.paisFk.nombre' },
  { text: 'Estado', value: 'estadoActual', },
  { text: 'Fecha de Creación', value: 'fechaCreacion', isDate: true, },
];

export default {
  name: "ListaFormulariosAdmin",
  extends: ListBase,
  props: {
    actions: {
      type: Array,
      default: () => [
        {
          name: DESCARGAR_ACTION,
          icon: 'get_app',
        },
      ],
    },
  },
  data: () => ({
    headers: formulariosHeader,
    title: 'Formularios',
    baseApi: 'formularios',
  }),
  computed: {
    ...mapState('auth', ['usuario',]),
    canCreate() {
      return false;
    },
    actionsComputed() {
      return this.usuario.exportador ? [
        {
          name: DESCARGAR_ACTION,
          icon: 'get_app',
        },
      ] : [];
    }
  },
}
</script>

<style scoped>

</style>
